// extracted by mini-css-extract-plugin
export default {"container":"ChargingTokenPageTabs_container__u7Ro+","tab":"ChargingTokenPageTabs_tab__k4+3G","text":"ChargingTokenPageTabs_text__fc9ta"};